import { render, staticRenderFns } from "./redPropaganda00.vue?vue&type=template&id=ff603d74&scoped=true&"
import script from "./redPropaganda00.vue?vue&type=script&lang=js&"
export * from "./redPropaganda00.vue?vue&type=script&lang=js&"
import style0 from "./redPropaganda00.vue?vue&type=style&index=0&id=ff603d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff603d74",
  null
  
)

export default component.exports